/**
 * Map deep-links. Every address offers BOTH Apple Maps and Google Maps; the
 * device hint only decides which we visually lead with — both always render.
 */

export function mapsQuery(locationName: string, address: string): string {
  return [locationName, address].filter(Boolean).join(', ');
}

export function appleMapsUrl(query: string): string {
  return `https://maps.apple.com/?q=${encodeURIComponent(query)}`;
}

export function googleMapsUrl(query: string): string {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
}

/** Client-only device hint. SSR-safe: returns false when navigator is absent. */
export function isAppleDevice(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /iPhone|iPad|iPod|Macintosh/.test(navigator.userAgent);
}
